import { Fragment } from 'react/jsx-runtime'
import { BatteryAlert, PowerOffOutlined, Warning } from '@mui/icons-material'
import { Typography, useTheme } from '@mui/material'

import NoSignalIcon from '../../../components/ui-icons/no-signal'
import SignalIcon from '../../../components/ui-icons/signal'
import useTemperatures from '../../../utils/hooks/useTemperatures'
import useStyles from '../index.styles'

const IssueIcons = ({
  nodeTypeName,
  nonUrgentAlertIssueTypes,
  isLowBattery,
  hasLowSignal,
  isCommunicating,
  temperature,
}: {
  nodeTypeName: string
  nonUrgentAlertIssueTypes: string[]
  isLowBattery: boolean
  hasLowSignal: boolean
  isCommunicating: boolean
  temperature: number | null | undefined
}) => {
  const classes = useStyles
  const theme = useTheme()
  const { formatTemperature } = useTemperatures()

  return (
    <>
      {isCommunicating && typeof temperature === 'number' && <Typography variant="body1">{formatTemperature(temperature, 'integer')}</Typography>}
      {nonUrgentAlertIssueTypes.map((alertIssueType) => {
        return (
          <Fragment key={alertIssueType}>
            {alertIssueType === 'temp-warning' && nodeTypeName !== 'nbiot_leak' && (
              <Warning fontSize="small" aria-label="Temperature Warning" sx={classes.issueWarningIcon} />
            )}
            {alertIssueType === 'gateway-on-battery' && <PowerOffOutlined color="error" fontSize="large" aria-label="Gateway is on battery power" />}
            {alertIssueType === 'generic-alert' && <Warning fontSize="medium" aria-label="Device has an active alert" sx={classes.issueWarningIcon} />}
          </Fragment>
        )
      })}
      {isLowBattery && isCommunicating && <BatteryAlert color="warning" fontSize="medium" aria-label="Device has low battery" sx={classes.issueWarningIcon} />}
      {hasLowSignal && isCommunicating && <SignalIcon value={2} isOffline={false} ariaLabel="Device has low signal" />}
      {nodeTypeName !== 'leak5s' && !isCommunicating && (
        <NoSignalIcon color={theme.palette.warning.light} secondaryColor={theme.palette.ui.surfaceDim} ariaLabel="Device is not communicating" />
      )}
    </>
  )
}

export default IssueIcons
